/**
 * <s-welcome-popup> — opens the <dialog> inside it once per visitor, shortly after arrival.
 * Attributes:
 *   delay       — ms to wait before opening (default 1500)
 *   storage-key — localStorage key that marks the popup as seen (default 'welcome-popup-seen')
 * Close/dismiss is handled by the wrapped <s-dialog> and Invoker Commands.
 */
class SWelcomePopup extends HTMLElement {
  #timer;

  connectedCallback() {
    const dialog = this.querySelector('dialog');
    if (!dialog) return;
    const key = this.getAttribute('storage-key') || 'welcome-popup-seen';
    try {
      if (localStorage.getItem(key)) return;
    } catch (e) {
      return;
    }
    const delay = Number(this.getAttribute('delay')) || 1500;
    this.#timer = setTimeout(() => {
      if (document.querySelector('dialog[open]')) return;
      dialog.showModal();
      try {
        localStorage.setItem(key, '1');
      } catch (e) {}
    }, delay);
  }

  disconnectedCallback() {
    clearTimeout(this.#timer);
  }
}

if (!customElements.get('s-welcome-popup')) {
  customElements.define('s-welcome-popup', SWelcomePopup);
}
